<template>
  <div class="layout-front">
    <LoadingOverlay v-if="loading" />
    <b-modal
      id="order-progress-bar"
      v-model="orderProgressBar.show"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      centered
      content-class="shadow"
      size="lg"
    >
      <b-progress
        :value="orderProgressBar.percent"
        :class="{ 'mt-5': orderProgressBar.text.length }"
        :variant="orderProgressBar.variant"
        striped
        animated
      />
      <p v-if="orderProgressBar.text.length" class="mt-3 text-center">
        {{ orderProgressBar.text }}
      </p>
    </b-modal>

    <div v-if="headerContentSlot" class="bg-dark text-white">
      <b-button v-b-toggle.offers-bar variant="dark" class="rounded-0" block>
        <b-container v-html="headerContentSlot.callout"></b-container>
      </b-button>
      <b-collapse id="offers-bar">
        <b-container class="pb-2" v-html="headerContentSlot.body" />
      </b-collapse>
    </div>

    <div class="care-container">
      <b-navbar toggleable="lg" class="site-header">
        <SelectLanguage class="nav-language-selector" />
        <div class="site-logo">
          <img
            :src="careByHallmarkLogo"
            class="site-header-logo d-inline-block align-top"
            alt="logo"
          />
          <img
            :src="logo"
            class="site-header-logo d-inline-block align-top"
            alt="logo"
          />
        </div>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown
              class="nav-selector"
              :text="'Hello, ' + name"
              right
            >
              <!-- <b-nav-item @click="toggleTheme">dark mode</b-nav-item> -->

              <b-nav-item @click="openHistory()">Order History</b-nav-item>
              <b-nav-item
                v-if="includeDashboardLink"
                :href="reportingURL"
                target="_blank"
                >Reporting &amp; Admin</b-nav-item
              >
              <b-nav-item to="logout"
                ><button class="sign-out">Sign Out</button></b-nav-item
              >
              <b-nav-item>
                <div class="theme-toggler" @click="toggleTheme">
                  <p>{{ darkStatus }}</p>
                  <label class="darkmode-switch" :class="themeDark">
                    <input type="checkbox" class="toggle" />
                    <div class="slider"></div>
                  </label>
                </div>
              </b-nav-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown
              right
              menu-class="text-danger"
              v-if="debug === true"
            >
              <template v-slot:button-content>
                <span class="text-danger">DEBUG</span>
              </template>
              <b-dropdown-item @click.prevent="$store.dispatch('placeOrder')">
                test order
              </b-dropdown-item>
              <b-dropdown-item
                @click.prevent="$store.dispatch('front/deleteAllBaskets')"
              >
                delete baskets
              </b-dropdown-item>
              <b-dropdown-item @click.prevent="$store.dispatch('ping/readUser')"
                >readUser</b-dropdown-item
              >
              <b-dropdown-item
                @click.prevent="$store.dispatch('ping/setRecentsCards')"
                >fix recents</b-dropdown-item
              >
              <b-dropdown-item
                @click.prevent="
                  (function ($store) {
                    const { favorites } =
                      $store.getters['ping/parsedIdToken'].userData;
                    let newdata = { favorites };
                    newdata.languages = ['en_US', 'es'];
                    newdata.sender_profiles = ['hbc'];
                    $store.dispatch('ping/updateUser', {
                      salesforceUserData: newdata,
                    });
                  })($store)
                "
                >Ping: update user salesforceUserData</b-dropdown-item
              >
              <b-dropdown-item
                @click.prevent="
                  (function ($store) {
                    $store.dispatch('ping/updateProfile', newProfile);
                  })($store)
                "
                >Update profile</b-dropdown-item
              >
              <b-dropdown-item
                @click.prevent="
                  (function ($store) {
                    const { favorites, sender_profiles } =
                      $store.state.ping.salesforceUserData;
                    let newdata = { favorites, sender_profiles };
                    newdata.languages = ['en_US', 'es'];
                    $store.dispatch('ping/updateOtherUser', {
                      userId: 'c8def554-3c14-4fe5-994a-dc44f58cdb9a',
                      data: { salesforceUserData: newdata },
                    });
                  })($store)
                "
                >Ping: Update Another User</b-dropdown-item
              >
              <b-dropdown-item
                @click.prevent="
                  $store.dispatch('ocapi/updateCustomer', {
                    c_pingPopulationID:
                      $store.getters['ping/parsedIdToken'].populationID,
                  })
                "
                >add ping Population ID to CC Customer</b-dropdown-item
              >
              <b-dropdown-item
                @click.prevent="
                  $store.dispatch('handleError', {
                    title: 'Manually triggered error',
                    message: 'There was an error',
                    data: {
                      test: ['a', 'b', 'c'],
                      thing: 'you already know',
                      another: { items: [], other: [1, 2, 3] },
                    },
                  })
                "
                >Test error</b-dropdown-item
              >
              <b-dropdown-item
                @click.prevent="
                  $store.dispatch(
                    'ping/tokenIntrospection',
                    $store.state.ping.userTokens.id_token
                  )
                "
                >Introspect ID Token</b-dropdown-item
              >
              <b-dropdown-item
                @click.prevent="$store.dispatch('ping/exchangeRefreshToken')"
                >Exchange Refresh Token</b-dropdown-item
              >
              <b-dropdown-item
                @click.prevent="
                  $store.dispatch(
                    'ping/tokenIntrospection',
                    $store.state.ping.userTokens.access_token
                  )
                "
                >Introspect Access Token</b-dropdown-item
              >
              <b-dropdown-item
                @click.prevent="$store.dispatch('front/fetchBlackoutDates')"
                >Fetch Blackout Dates</b-dropdown-item
              >
              <b-dropdown-item
                @click.prevent="
                  $store.dispatch('front/fetchOcapiLoginForCurrentPingUser')
                "
                >Search For Current User</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>

    <b-modal
      modal-class="modal-fullscreen"
      id="order-history"
      hide-header
      hide-footer
      fade
      v-model="showOrderHistory"
      no-close-on-esc
      no-close-on-backdrop
    >
      <OrderHistory @close="closeOrderHistory" />
    </b-modal>

    <router-view />
  </div>
</template>

<script>
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import SelectLanguage from '@/components/SelectLanguage.vue';
import OrderHistory from '@/components/OrderHistory.vue';
import Cookies from 'js-cookie';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

/* eslint-disable no-console */
export default {
  name: 'Home',
  components: {
    LoadingOverlay,
    OrderHistory,
    SelectLanguage,
  },
  data() {
    return {
      showOrderHistory: false,
      theme: '',
      themeStatus: '',
      themeClass: '',
    };
  },
  computed: {
    ...mapState(['debug']),
    ...mapState('front', ['loading', 'orderProgressBar']),
    ...mapState('ping', ['config']),
    ...mapState('ocapi', ['customerGroup']),
    ...mapGetters('ping', ['parsedIdToken']),
    ...mapGetters('front', ['isDarkMode']),
    ...mapGetters('ocapi', ['headerContentSlot']),
    newProfile() {
      let profile = Object.assign({}, this.parsedIdToken.profile);
      profile.role = '';
      return profile;
    },
    includeDashboardLink() {
      const role = this.parsedIdToken?.profile?.role;
      return role === 'admin' || role === 'clientadmin' || role === 'reporting';
    },
    reportingURL() {
      let urlSuffix = '';
      let clientID = Cookies.get('client');
      if (this.config?.policy && clientID) {
        urlSuffix = 'sso/' + clientID;
      } else if (clientID) {
        urlSuffix = clientID;
      }
      return process.env.VUE_APP_DASHBOARD_URL + urlSuffix;
    },
    logo() {
      return (
        this.customerGroup?.c_clientLogo?.abs_url ||
        `/images/logos/${this.config.logo}`
      );
    },
    careByHallmarkLogo() {
      var path = this.customerGroup?.c_clientLogo?.abs_url
      return (
        path ? (path.substring(0, path.lastIndexOf('/')) + '/carebyhmk.png') : ''
      );
    },
    name() {
      return this.parsedIdToken?.given_name || '';
    },
    darkStatus() {
      return !this.isDarkMode ? 'Dark Mode' : 'Light Mode';
    },
    themeDark() {
      return !this.isDarkMode ? '' : 'dark-theme';
    },
  },
  methods: {
    ...mapMutations('front', ['startLoading', 'stopLoading']),
    ...mapActions('front', ['fetchOrderHistory']),
    closeOrderHistory() {
      this.$bvModal.hide('order-history');
    },
    openHistory() {
      this.startLoading();
      this.showOrderHistory = true;
      this.fetchOrderHistory()
        .then(() => {
          this.stopLoading();
        })
        .catch((error) => {
          this.stopLoading();
          console.error(error);
        });
    },
    toggleTheme() {
      let updateDarkMode = !this.isDarkMode;
      let toggleDarkMode = !updateDarkMode ? '' : 'dark-theme'; //toggles theme value
      this.themeStatus = updateDarkMode ? 'Dark Mode' : 'Light Mode';
      this.themeClass = !this.isDarkMode ? '' : 'dark-theme';
      document.documentElement.setAttribute('data-theme', toggleDarkMode); // sets the data-theme attribute
      this.$store.dispatch('ping/setDarkModePreference', updateDarkMode);
    },
  },
  mounted() {
    document.documentElement.setAttribute(
      'data-theme',
      !this.isDarkMode ? '' : 'dark-theme'
    ); // updates the data-theme attribute
    this.themeStatus =
      this.isDarkMode === 'dark-theme' ? 'Dark Mode' : 'Light Mode';
    this.themeClass = !this.isDarkMode ? '' : 'dark-theme';
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
@import '../scss/variables';

.site-header {
  display: flex;
  justify-content: space-between;
  width: -webkit-fill-available;
  height: 75px;

  @media (max-width: $phone-width) {
    height: 90px;
  }
}

.site-header-logo {
  max-height: 60px;
  width: auto;
  display: block;
  // @media (max-width: $phone-width){
  //   max-height: 40px;
  // }
}

.layout-front {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: -webkit-fill-available;
}

// product borders
$border-color: #e7e7e7;

.product {
  border-top: 1px solid $border-color;

  &:first-child {
    border-top: none;
  }

  @media (min-width: 768px) {
    &:nth-child(2) {
      border-top: none;
    }

    &:nth-child(even) {
      border-left: 1px solid $border-color;
    }
  }

  @media (min-width: 992px) {
    &:nth-child(n) {
      border-left: 0;
    }

    &:nth-child(3) {
      border-top: none;
    }

    &:nth-child(3n),
    &:nth-child(3n - 1) {
      border-left: 1px solid $border-color;
    }
  }

  @media (min-width: 1200px) {
    &:nth-child(n) {
      border-left: 0;
    }

    &:nth-child(4) {
      border-top: none;
    }

    &:nth-child(4n),
    &:nth-child(4n - 1),
    &:nth-child(4n - 2) {
      border-left: 1px solid $border-color;
    }
  }
}

::v-deep .modal-fullscreen {
  padding: 0 !important;
}

::v-deep .modal-fullscreen .modal-header {
  border-radius: 0 !important;
  border-color: transparent;
  background-color: transparent;
}

::v-deep .modal-fullscreen .modal-dialog {
  max-width: 100%;
  height: 100%;
  margin: 0;
}

::v-deep .modal-fullscreen .modal-body {
  background-color: transparent;
}

::v-deep .modal-fullscreen .modal-content {
  background-color: transparent;
  border: 0;
  border-radius: 0;
  min-height: 100%;
  height: auto;
}

::v-deep .modal-fullscreen + .modal-backdrop {
  opacity: 0.8;
}

::v-deep .navbar {
  padding: 0;
}

::v-deep .navbar-nav + .dropdown-menu {
  background-color: $base-white;
}

::v-deep .navbar-nav .dropdown-menu {
  background-color: $base-white;
  border-radius: 12px;
  box-shadow: 2px 6px 6px 2px #00000060;
  padding: 0;
  margin: 0;
  overflow: hidden;

  .nav-item:nth-child(1) {
    margin-top: 0.6rem;
  }

  .nav-link {
    color: $font-base;
    padding: 0.4rem 0.8rem;
    white-space: nowrap;
  }

  .nav-item:nth-child(3) {
    margin-bottom: 0.6rem;
  }

  .nav-item:nth-child(4) {
    background-color: $base-light;
    .nav-link {
      background-color: $base-light;
    }
  }
}
</style>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
@import '../scss/variables';

body {
  background-color: $base-white;
}

#order-progress-bar___BV_modal_outer_ {
  z-index: 99999999 !important;
}
.navbar-light .navbar-toggler {
  color: $font-base;
  background-color: $highlight;
}
.navbar-nav {
  @media (max-width: 991px) {
    text-align: right;
    background-color: $base-white;
    z-index: 5;
    position: relative;
    box-shadow: 1px 2px 10px -2px;
    padding: 0.4rem 0.8rem;

    .nav-item {
      color: $font-base;
      text-align: right;
    }
    .darkmode-switch {
      margin-left: auto;
    }
  }
}

.nav-language-selector {
  display: none !important;

  @media (max-width: $phone-width) {
    display: none;
  }
}

/*.nav-selector {
  span,
  ::after {
    color: $font-base;
  }
}*/

.theme-toggler {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  background-color: $base-light;

  p {
    margin-bottom: 0;
    color: $font-base;
  }

  .darkmode-switch {
    position: relative;
    display: inline-block;
    width: 66px;
    height: 32px;
    margin-top: 0.4rem;

    .toggle {
      display: none;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: $bg-darkmode;
      // border: solid 1px $bg-border;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: 40px;
    }

    &.dark-theme {
      .slider:before {
        position: absolute;
        content: '';
        height: 26px;
        width: 26px;
        left: 3px;
        bottom: 3px;
        background-color: white;
        background-image: url(../assets/moon.svg);
        background-size: 16px;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 40px;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }

      .slider:before {
        -webkit-transform: translateX(33px);
        -ms-transform: translateX(33px);
        transform: translateX(33px);
      }
    }

    .slider:before {
      position: absolute;
      content: '';
      height: 26px;
      width: 26px;
      left: 3px;
      bottom: 3px;
      background-color: white;
      background-image: url(../assets/sun.svg);
      background-size: 16px;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: 40px;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }
  }
}
.care-container {
  display: flex;
  flex-direction: row;
  max-width: calc(100% - 10vw);
  margin: auto;
  @media (max-width: $phone-width) {
    max-width: none;
    flex-direction: column;
    padding: 0 2rem;
    margin: none;
  }
}
.care-container:has(.site-header) {
  background-color: #fff;
  max-width: 100%;
  padding: 0 5vw;
}
.sign-out {
  color: #373534;
  background-color: $base-yellow;
  border: $base-yellow;
  width: -webkit-fill-available;
  border-radius: 4px;
  font-weight: 600;
  padding: 0.2rem;
  max-width: 180px;
}
</style>
